import { useTranslation } from "react-i18next";
import TabsRoot from "../molecules/tabs/TabsRoot";
import RetailForm from "../organisms/forms/retail/RetailForm";
import Content from "../templates/wrapper/Content";

const Retail = () => {
  const { t } = useTranslation();

  const tabsData = [
    {
      value: "account",
      label: t("retail.createAccount"),
      content: <RetailForm />,
    },
  ];

  return (
    <Content>
      <TabsRoot tabs={tabsData} defaultValue="account" />
    </Content>
  );
};

export default Retail;
